import React, { useState, useEffect } from "react";
import MainLayout from "layout/MainLayout";
import { Form, Field } from "react-final-form";
import axios from "utils/axios";
import cookie from "react-cookies";
import { toast } from "react-toastify";
import FinalFormInput from "components/FinalFormInput";
import AddressAutocomplete from "components/AddressAutocomplete";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const options = ["Food", "Health", "Sleep", "Legal", "Education", "Library"];

const CreateResource = () => {
  const [address, setAddress] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [street, setStreet] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const ss = document.getElementById("address") as HTMLInputElement;

    const autocomplete = new window.google.maps.places.Autocomplete(ss, {
      types: ["address"],
    });
    autocomplete.setComponentRestrictions({
      country: ["us"],
    });
    autocomplete.addListener("place_changed", function (this: any) {
      const place = this.getPlace();
      let tempAddress = place.formatted_address;
      const value = tempAddress.split(", ");
      const count = value.length;
      let tempCity = value[count - 3];
      let tempState = value[count - 2].slice(0, 2);
      let tempStreet = place.name;
      setStreet(tempStreet);
      setCity(tempCity);
      setState(tempState);
      setAddress(tempAddress);
    });
  }, []); //eslint-disable-line

  useEffect(() => {
    if (
      cookie.load("create-resource") &&
      cookie.load("create-resource").status === true
    ) {
      cookie.remove("create-resource");
    }
  });

  const handleClick = () => {};

  const createResource = async (val: any) => {
    let {
      type,
      name,
      phoneNumber,
      email = "",
      websiteLink = "",
      description,
    } = val;
    phoneNumber = phoneNumber.replace(/\D/g, "");
    if (phoneNumber.length !== 10) {
      toast.warning("Please type 10 digit phone number");
      return;
    }
    if (
      email !== "" &&
      !email
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      toast.warning("Please type vaild email address");
      return;
    }
    if (websiteLink !== "" && !websiteLink.includes("https://"))
      websiteLink = "https://" + websiteLink;
    Swal.fire({
      title: "<h6>Are you sure you want to create this resource?</h6>",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: `Confirm`,
      denyButtonText: `Cancel`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const { tokenId, title: username, organization } = cookie.load("user");
        try {
          await axios.post("/api/resource/create", {
            tokenId: Number(tokenId),
            username,
            organization,
            type,
            name,
            address,
            street,
            city,
            state,
            phoneNumber,
            email,
            websiteLink,
            description,
          });
          cookie.save("create-resource", { status: true }, { path: "/" });
          if (cookie.load("user").userType === "user")
            navigate(`/profile/${cookie.load("user").tokenId}`);
          else navigate("/dashboard");
          toast.success("Successfully create a resource");
        } catch (error: any) {
          toast.error(error.response.data.message);
        }
      } else if (result.isDenied) {
        return;
      }
    });
  };

  return (
    <MainLayout title="Create Resource">
      <Form
        onSubmit={(val: any) => createResource(val)}
        render={({ handleSubmit }) => (
          <form
            className="containers my-20 sm:my-[36px] xl:w-[613px] lg:w-[613px] md:max-w-[613px] flex flex-col"
            onSubmit={handleSubmit}
          >
            <h4>Create a Resource</h4>
            <div className="content grid gap-[20px] mt-12 sm:mt-10 mb-[32px]">
              <Field id="type" name="type">
                {(props: any) => (
                  <FinalFormInput
                    {...props}
                    component="select"
                    options={options}
                    defaultValue="Food"
                    placeholder="Type"
                    required
                  />
                )}
              </Field>
              <Field id="name" name="name" placeholder="Name">
                {(props: any) => <FinalFormInput {...props} required />}
              </Field>
              <Field id="address" name="address" placeholder="Address">
                {(props: any) => (
                  <AddressAutocomplete {...props} value={address} required />
                )}
              </Field>
              <Field
                id="phoneNumber"
                name="phoneNumber"
                placeholder="Phone Number"
              >
                {(props: any) => <FinalFormInput {...props} required />}
              </Field>
              <Field id="email" name="email" placeholder="Email">
                {(props: any) => <FinalFormInput {...props} />}
              </Field>
              <Field
                id="websiteLink"
                name="websiteLink"
                placeholder="Website Link"
              >
                {(props: any) => <FinalFormInput {...props} />}
              </Field>
              <Field
                id="description"
                name="description"
                placeholder="Description"
                rows={8}
              >
                {(props: any) => (
                  <FinalFormInput {...props} component="textarea" required />
                )}
              </Field>
            </div>
            <button
              type="submit"
              className="high-emphasis ml-auto"
              onClick={() => handleClick}
            >
              SUBMIT
            </button>
          </form>
        )}
      />
    </MainLayout>
  );
};

export default CreateResource;
